import * as Yup from 'yup';

export default Yup.object().shape({
  payquick_vip_merchant_number: Yup.string().optional(),
  payquick_vip_hash_key: Yup.string().optional(),
  payquick_prepaid_merchant_number: Yup.string().optional(),
  payquick_prepaid_hash_key: Yup.string().optional(),
});
